module.exports = __webpack_public_path__ + "static/media/271072.c89fee46.png";